import { indexItems } from '@/mocks/homeData';

export default function IndexSection() {
  return (
    <section id="index" className="py-16 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-screen-2xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">分类索引</h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            按类型快速浏览，精准找到你想看的影视内容
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-4 max-w-5xl mx-auto">
          {indexItems.map((item, index) => (
            <div
              key={item.id}
              className="flex flex-col items-center gap-3 p-5 rounded-xl bg-background-100 border border-background-200/70 hover:border-primary-200 hover:bg-primary-50/50 transition-all duration-300 cursor-pointer"
              style={{ animation: `fadeInUp 0.4s ease-out ${index * 0.08}s both` }}
            >
              <span className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-100 flex-shrink-0">
                <i className={`${item.icon} text-accent-600 text-xl`}></i>
              </span>
              <div className="text-center">
                <div className="font-medium text-foreground-950 text-sm whitespace-nowrap">{item.name}</div>
                <div className="text-xs text-foreground-400 mt-0.5">{item.count}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}